export const SET_TASK_TABLE_PER_PAGE = 'SET_TASK_TABLE_PER_PAGE';
export const SET_TASK_VIEW_TYPE = 'SET_TASK_VIEW_TYPE';
